<script setup>
import { computed, onMounted, reactive, ref } from "vue";
import { queryOrgTree } from "@/api/common";
import {
  queryReflectionByPlantId,
  insertReflection,
  updateReflection,
} from "@/api/reflection";
import { ElMessage } from "element-plus";

// 页面标题
const title = "账号名称映射配置";

const isEmpty = ref(true);

const saveType = computed({
  get() {
    return formData.id ? "edit" : "add";
  },
});

// 新增编辑API
const adjustApi = reactive({
  add: insertReflection,
  edit: updateReflection,
});

// 页面loading
const loading = ref(false);

// 组织树数据
const treeData = ref([]);

// 树配置
const defaultProps = reactive({
  children: "children",
  label: "organizationName",
});

// 树遮罩
const treeLoading = ref(false);

// 名称配置ref
const ruleRef = ref(null);

// 名称配置表单
const formData = reactive({
  id: null,
  plantsId: null,
  hkName: null,
});

// 名称校验
const rules = reactive({
  hkName: [{ required: true, message: "请输入海康区域名称", trigger: "blur" }],
});

//树点击事件
const handleNodeClick = (data) => {
  isEmpty.value = false;
  formData.plantsId = data.organizationCode;
  getOrgNameByPlantId(data.organizationCode);
};

// 获取组织的name配置
const getOrgNameByPlantId = (id) => {
  loading.value = false;
  queryReflectionByPlantId(id)
    .then((res) => {
      if (res.data.total > 0) {
        formData.id = res.data.records[0].id;
        formData.hkName = res.data.records[0].hkName;
        formData.plantsId = res.data.records[0].plantsId;
      } else {
        formData.id = null;
        formData.hkName = null;
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

// 获取树结构
const getTreeData = () => {
  treeLoading.value = true;
  queryOrgTree({})
    .then((res) => {
      treeData.value = res.data || [];
    })
    .finally(() => {
      treeLoading.value = false;
    });
};

// 点击保存
const formSubmit = () => {
  ruleRef.value?.validate((valid) => {
    if (valid) {
      adjustApi[saveType.value](formData).then((res) => {
        if (res.code == "2000") {
          ElMessage.success("操作成功");
        }
      });
    }
  });
};

onMounted(() => {
  getTreeData();
});
</script>

<template>
  <zh-table-page v-bind="{ title }">
    <template #header-btn>
      <el-button type="primary" :disabled="isEmpty" @click="formSubmit()"
        >保存</el-button
      >
    </template>
    <template #search></template>
    <template #left>
      <el-tree
        :data="treeData"
        node-key="organizationCode"
        :props="defaultProps"
        :expand-on-click-node="false"
        ref="tree"
        default-expand-all
        @node-click="handleNodeClick"
        highlight-current
        v-loading="treeLoading"
      />
    </template>
    <template #table>
      <el-empty
        v-show="isEmpty"
        :image="require('@/assets/images/none.png')"
        description="请选择公司或厂站"
        style="height: 100%"
        :image-size="200"
      />
      <el-form ref="ruleRef" :model="formData" :rules="rules" v-show="!isEmpty">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="海康区域名称:" prop="hkName">
              <el-input
                v-model="formData.hkName"
                placeholder="请输入海康区域名称"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
  </zh-table-page>
</template>

<style lang="scss" scoped></style>
